import React from 'react';

function TrunkAuth(props) {
  const { changeValues, tenants } = props;
/*
    Autenticado:
      {
        "provider": "Algar",
        "ipSbcTrunk": "172.23.1.1",
        "ipLocal": "",
        "trunkNumber": "",
        "codec": "alaw",
        "authUsername": "vigos@vigos",
        "password": "123456",
        "type": "AUTH"
      }
  */

      return (
        <div>
          <div className="columns mx-2">
            <div className="column is-4 field">
              <label className="label">Nome Operadora
                <div className="control">
                  <input className="input" name="provider" type="text" onChange={(e) => changeValues(e.target)} placeholder="Nome" />
                  <p name="provider-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
              </label>
            </div>
            <div className="column is-3 field">
              <label className="label">Nome de Usuario
                <div className="control">
                  <input className="input" name="authUsername" type="text" onChange={(e) => changeValues(e.target)} placeholder="a1bc56n" />
                  <p name="authUsername-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
              </label>
            </div>
            <div className="column is-3 field">
              <label className="label">Senha
                <div className="control">
                  <input className="input" name="password" type="text" onBlur={(e) => changeValues(e.target)} placeholder="Minimo 6 carac." />
                  <p name="password-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
              </label>
            </div>
            <div className="column is-3 field">
              <label className="label">Cliente
                <div className="control">
                  <div name="tenant" className="select is-fullwidth">
                    <select className="select" name="tenant" onChange={(e) => changeValues(e.target)} >
                      <option value=""> Selecione </option>
                      { tenants.map((tenant) => <option key={`${tenant.short_name}`} value={tenant.short_name}>{ tenant.name }</option>) }
                    </select>
                  </div>
                </div>
              </label>
            </div>
          </div>
          <div className="columns mx-2">
            <div className="column is-4 field">
              <label className="label">IP SIP (Operadora)
                <div className="control">
                  <input className="input" name="ipSbcTrunk" type="text" onBlur={(e) => changeValues(e.target)} placeholder="1.0.0.1" />
                  <p name="ipSbcTrunk-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
              </label>
            </div>
            <div className="column is-5 field is-centered has-text-centered">
              <div className="columns mt-1 pl-4 has-text-centered"><b className='has-text-centered'>Codec</b>
                <div className="column is-multiline">
                  <div className="is-fullwidth"> ALAW <br/>
                    <input className='ml-2' name="codec" type="checkbox" value="alaw" onChange={ (e) => changeValues(e.target)}/>
                  </div>
                </div>
                <div className="column is-multiline is-centered">
                  <div className="is-fullwidth"> ULAW <br/>
                    <input className='ml-3' name="codec" type="checkbox" value="ulaw" onChange={ (e) => changeValues(e.target)}/>
                  </div>
                </div>
                <div className="column is-multiline is-centered">
                  <div className="is-fullwidth"> G.729 <br/>
                    <input className='ml-3' name="codec" type="checkbox" value="g729" onChange={ (e) => changeValues(e.target)}/>
                  </div>
                </div>
                <div className="column is-multiline is-centered">
                  <div className="is-fullwidth"> H.264 <br/>
                    <input className='ml-3' name="codec" type="checkbox" value="h264" onChange={ (e) => changeValues(e.target)}/>
                  </div>
                </div>
              </div>
            </div>
            <div className="column is-4 field">
              <label className="label">Modo 
                <div className="control">
                  <div name="mode" className="select is-fullwidth">
                    <select className="select" name="mode" onChange={(e) => changeValues(e.target)} >
                      <option value=""> Selecione </option>
                      <option value="bidirecional"> Bidirecional </option>
                      <option value="unidirecional"> Unidirecional </option>
                    </select>
                  </div>
                </div>
              </label>
            </div>
          </div>
        </div>
      );
}

export default TrunkAuth;
